// Chart styling

export const chartStyle = {        
		backgroundColor: "rgba(0,123,255,0.1)",
        borderColor: "rgba(0,123,255,1)",
        pointBackgroundColor: "#ffffff",
        pointHoverBackgroundColor: "rgb(0,123,255)",
        borderWidth: 1.5,
        pointRadius: 0,
        pointHoverRadius: 3
      };
export const chartStyleLosses = {
	 	backgroundColor: "rgba(255,65,105,0.1)",
        borderColor: "rgba(255,65,105,1)",
        pointBackgroundColor: "#ffffff",
        pointHoverBackgroundColor: "rgba(255,65,105,1)",
        borderWidth: 1,
        pointRadius: 0,
        pointHoverRadius: 2
};
export const chartStyleWins = {
  	    backgroundColor: "rgba(0,250,154,0.1)",
	    borderColor: "rgb(0,250,154)",
	    pointBackgroundColor: "#ffffff",
	    pointHoverBackgroundColor: "rgb(0,250,154)",
	    borderWidth: 1.5,
	    pointRadius: 0,
	    pointHoverRadius: 3
};
export const pieChartStyles = {
		hoverBorderColor: "#ffffff",
		backgroundColor: ["rgba(0,123,255,0.9)",
		"rgba(0,123,255,0.3)"]
};
export const pieChartStyles3 = {
		hoverBorderColor: "#ffffff",
		backgroundColor: ["rgba(0,123,255,0.8)",
		"rgba(255,65,105,0.6)"]
};
export const pieChartStyles2 = {
		hoverBorderColor: "#ffffff",
		backgroundColor: [	"rgba(0,123,255,0.9)",
    						"rgba(0,123,255,0.8)",
	    					"rgba(0,123,255,0.7)",
	    					"rgba(0,123,255,0.6)",
	    					"rgba(0,123,255,0.5)",
	    					"rgba(0,123,255,0.4)",
	    					"rgba(0,123,255,0.3)"]

}
export const barChartStyle1 = {
		hoverBorderColor: "#ffffff",
	    maxBarThickness: 20,
	    minBarLength: 4,
	    backgroundColor: [
      						"rgba(0,123,255,0.9)",
      						"rgba(0,123,255,0.9)",
      						"rgba(0,123,255,0.9)",
      						"rgba(0,123,255,0.9)"]
};
export const barChartStyle2 = {
		hoverBorderColor: "#ffffff",
	    maxBarThickness: 20,
	    minBarLength: 4,
	    backgroundColor: [
					      "rgba(0,123,255,0.2)",
					      "rgba(0,123,255,0.2)",
					      "rgba(0,123,255,0.2)",
					      "rgba(0,123,255,0.2)"]
}

export const radarChartStyles = {
      	backgroundColor: "rgba(0,123,255,0.1)",
        borderColor: "rgba(0,123,255,1)",
        pointBackgroundColor: "#ffffff",
        pointHoverBackgroundColor: "rgb(0,250,154)",
        borderWidth: 1.5,
        pointRadius: 2,
        pointHoverRadius: 3
};